import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ContentViewComponent from '../../../../Component/ContentViewComponent/ContentViewComponent';
import { getRoutePathname } from '../../../../Handler/RouteHandler';
import { initFormHandler } from '../../../../Handler/FormHandler';
import { Grid2 as Grid } from '@mui/material';
import TextFieldComponent from '../../../../Component/TextFieldComponent/TextFieldComponent';
import ButtonComponent from '../../../../Component/ButtonComponent/ButtonComponent';
import ApiHandler from '../../../../Handler/ApiHandler';
import { dispatch } from '../../../../App';
import { SnackbarOpen } from '../../../../Reducer/SnackBarReducer/SnackBarSlice';

function PrestationGroup() {
    const [loading, setLoading] = React.useState(true);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [isEdit, setIsEdit] = React.useState(true);
    const [info, setInfo] = React.useState();
    const params = useParams();
    const navigate = useNavigate();

    const [form, setForm] = React.useState({
        label: {
            name: "label",
            label: "Libellé",
            textHelper: "Saisissez le nom du groupe.",
            type: "text",
            defaultValue: "",
            options: { validation: ["required"], min: 1, max: 255 },
        },
        description: {
            name: "description",
            label: "Description",
            textHelper: "Optionnel.",
            type: "text",
            defaultValue: "",
            options: {},
        },
    });
    const handlerForm = initFormHandler(form, setForm);
    React.useEffect(() => {
        handlerForm.start();
    }, [handlerForm]);

    React.useEffect(() => {
        setBreadcrumbs({
            title: 'Configuration',
            context: isEdit ? 'Éditer un groupe de prestation' : 'Ajouter un groupe de prestation',
            description: '',
            links: [
                { label: "Groupes de prestations", path: getRoutePathname("configuration_prestation_group_list") }
            ]
        });

        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, [isEdit]);

    React.useEffect(() => {
        if (params.id === 'add') {
            setIsEdit(false);
            return;
        }

        ApiHandler.get({
            route: 'configuration_prestation_group_get',
            params: { id: params.id },
        },
            (response) => {
                if (response.status === 200) {
                    handlerForm.setDataApi(response.data);
                    setInfo(response.data);
                }
                else {
                    dispatch(
                        SnackbarOpen({
                            text:
                                response.error && response.error.message
                                    ? response.error.message
                                    : "Une erreur inattendu s'est produite.",
                            variant: "error",
                        }),
                    );
                    navigate(getRoutePathname('configuration_prestation_group_list'));
                }
            });
    }, [handlerForm, navigate, params.id]);

    const save = () => {
        if (handlerForm.checkError() < 1) {
            handlerForm.setFormLoading(true);
            ApiHandler.post(
                {
                    route: isEdit ? "configuration_prestation_group_edit" : "configuration_prestation_group_add",
                    params: isEdit ? { id: info.id } : "",
                    data: handlerForm.getData(),
                },
                (response) => {
                    if (response.status === 200 || response.status === 201) {
                        if (response.status === 201) {
                            navigate(getRoutePathname('configuration_prestation_group', { id: response.data.id }));
                        }
                        dispatch(
                            SnackbarOpen({
                                text: isEdit ? "Groupe modifié avec succès" : "Groupe créé avec succès",
                                variant: "success",
                            }),
                        );
                    } else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    } else {
                        dispatch(
                            SnackbarOpen({
                                text:
                                    response.error && response.error.message
                                        ? response.error.message
                                        : "Une erreur inattendu s'est produite.",
                                variant: "error",
                            }),
                        );
                    }
                    handlerForm.setFormLoading(false);
                },
            );
        }
    };

    return (
        <ContentViewComponent loading={loading} breadcrumbs={breadcrumbs}>
            <Grid container spacing={1}>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <TextFieldComponent id={"label"} handler={handlerForm} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <TextFieldComponent id={"description"} handler={handlerForm} multiline />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <ButtonComponent style={{ width: '100%', marginTop: '20px' }} label={"Enregistrer"} onClick={save} />
                </Grid>
            </Grid>
        </ContentViewComponent>
    );
}

export default PrestationGroup;
